// extracted by mini-css-extract-plugin
export default {"verticalCenter":"ttICwfys7nfIxE0bT2pk"};